import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { PaymentProofs, PaymentProofsProps } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { ReactComponent as ProofSvg } from 'modules/PaymentsPage/img/proof.svg'

import { selectLocaleDict } from 'features/locale/selectors'

import { addNotify } from 'components/Notify'

import './PaymentScreens.scss'

const b = block('payment-screens')

type PaymentScreensProps = PaymentProofsProps

export const PaymentScreens = React.memo(function PaymentScreens(props: PaymentScreensProps) {
  const { payment } = useSelector(selectLocaleDict, shallowEqual)

  const ntfCallback = (txt: string) => {
    addNotify(txt, 'error')
  }

  if (!props.enabled) return null
  return (
    <div className={b()}>
      {/* {showError && <div className={b('error')}>{error || payment.uploadOneScreen}</div>} */}
      <PaymentProofs {...props} ntfCallback={ntfCallback} className={b('dropzone')}>
        {({ files, paymentProofs, handleRemove, disabled }) => (
          <div className={b('files-container')}>
            {files?.map((file, index) => (
              <div
                key={`${file.name}_${Date.now() + index}`}
                className={b('image-container', { error: Boolean(paymentProofs?.[index]?.errorMessage) })}>
                <div className={b('image-content')}>
                  <img src={URL.createObjectURL(file)} alt="preview" className={b('image')} />
                  <div
                    className={b('delete-button')}
                    onClick={e => {
                      e.stopPropagation()
                      handleRemove(index)
                    }}>
                    ✕
                  </div>
                </div>
              </div>
            ))}
            {!disabled ? (
              <div className={b('file-wrapper', { click: true, upload: true })}>
                <span className={b('icon-wrapper')}>
                  <ProofSvg className={b('icon')} />
                </span>
                <span>{payment.uploadPhoto}</span>
              </div>
            ) : null}
          </div>
        )}
      </PaymentProofs>
      {/* <div className={b('text')}>{payment.uploadScreen}</div> */}
    </div>
  )
})
